import { Css, Tooltip } from "@homebound/beam";
import { emptyCellDash } from "src/components";

type TruncatedNameListCellProps = {
  nameList: (string | React.ReactNode)[];
  tooltipNameList?: (string | React.ReactNode)[];
};

export function TruncatedNameListCell(props: TruncatedNameListCellProps) {
  const { nameList, tooltipNameList } = props;
  const [opt1, ...others] = nameList;
  const tooltipNodes = tooltipNameList ?? nameList;

  // If we only have the one, then we can just display it - no Tooltip needed
  if (others.isEmpty) return <span css={Css.truncate.$}>{opt1 ?? emptyCellDash}</span>;

  // lets us join react nodes with commas, instead of converting them to strings
  // so we can display styled things like a red (Archived) label
  const joinNodes = (nodeArray: React.ReactNode[]) => nodeArray.reduce((acc, curr) => [acc, ", ", curr]);

  function renderTooltipContent() {
    return (
      <div css={Css.df.fdc.gapPx(2).whiteSpace("normal").$}>
        {tooltipNodes.map((node, index) => (
          <div key={index}>{node}</div>
        ))}
      </div>
    );
  }

  // Otherwise, we have at least 2 names in the list.
  // Display two inline, a count of the remainder, and a Tooltip with the full list.
  return (
    <div css={Css.df.aic.mw0.onActive.add("pointerEvents", "none").$}>
      <Tooltip title={renderTooltipContent()}>
        <span css={Css.truncate.$}>{joinNodes([opt1, others[0]])}</span>
        {others.length > 1 && <span>+{others.length - 1}</span>}
      </Tooltip>
    </div>
  );
}
